const SignUp_en = {
  ID_SIGNUP_TITLE: "Sign Up",
  ID_SIGNUP_EMAIL: "Email",
  ID_SIGNUP_PWD: "Password",
  ID_SIGNUP_NICKNAME: "Nickname",
  ID_SIGNUP_VERIFY_CODE: "Auth Code",
  ID_SIGNUP_ERROR_EMPTY_EMAIL: "Please enter your email.",
  ID_SIGNUP_EMAIL_PLACEHOLDER: "Please enter email address.",
  ID_SIGNUP_EMAIL_VERIFY_BTN: "Send mail",
  ID_SIGNUP_PWD_PLACEHOLDER: "Please enter password",
  ID_SIGNUP_NAME_PLACEHOLDER: "Please enter a nickname.",
  ID_SIGNUP_NAME_ERROR: "Please enter a nickname.",
  ID_SIGNUP_BDAY: "Birthdate",
  ID_SIGNUP_PWD_DIGIT: "Minimum 8 letters",
  ID_SIGNUP_PWD_PATTERN: "Configure with letters and numbers",
  ID_SIGNUP_YEAR: "Year",
  ID_SIGNUP_MONTH: "Month",
  ID_SIGNUP_DATE: "Day",
  ID_SIGNUP_SUBMIT_BTN: "Create an account",
  ID_SIGNUP_LOGIN_DESC: "Already a member of Redbrick? ",
  ID_SIGNUP_LOGIN_LINK: " Please Log in",
  ID_SIGNUP_AGREE_ALL: "I agree to all terms and conditions.",
  ID_SIGNUP_AGREE_SERVICE:
    "[Requirement] I accept the Redbrick Integration {link}",
  ID_SIGNUP_AGREE_SERVICE_LINK: "Service Terms and Conditions",
  ID_SIGNUP_AGREE_PRIVACY: "[Requirement] I agree with the {link}",
  ID_SIGNUP_AGREE_PRIVACY_LINK: "privacy policy",
  ID_SIGNUP_AGREE_MARKETING:
    "[Optional] I agree to receive service information.",
  ID_SIGNUP_SERVICE_TERMS:
    "These terms and conditions are common to Redbrick and WizLive services provided by the company, and by agreeing to these terms and conditions, these services can be used without signing a separate use contract.",
  ID_SIGNUP_EMAIL_FORMAT_ERROR: "Please enter email address accordingly",
  ID_SIGNUP_EMAIL_DUPLICATE_ERROR: "This email address is already in use.",
  ID_SIGNUP_EMAIL_DUPLICATE_VALID: "This email address in available for use.",
  ID_SIGNUP_EMAIL_BIRTH_ERROR: "Please enter date of birth.",
  ID_SIGNUP_MAN_AGREE_ERR:
    "Please agree to the mandatory terms and conditions.",
  ID_SIGNUP_EMAIL_SERVICE_AGREE_ERROR:
    "Please agree to the mandatory terms and conditions.",
  ID_SIGNUP_EMAIL_PRIVACY_AGREE_ERROR:
    "Please agree to the mandatory terms and conditions.",
  ID_SIGNUP_CODE_VERIFY_BTN: "Confirm",
  ID_SIGNUP_EMAIL_SENDING: "Sending...",
  ID_SIGNUP_CODE_PLACEHOLDER: "Please enter your authentication code.",
  ID_SIGNUP_EMAIL_WAITING: "Waiting for authentication",
  ID_SIGNUP_CODE_VERIFY_ERROR:
    "Please enter the authentication code correctly..",
  ID_SIGNUP_EMAIL_CODE_PLACEHOLDER: "Please enter your authentication code.",
  ID_SIGNUP_CODE_VERIFY_TIMEOUT:
    "The authentication code has expired. Please send an authentication email again.",
  ID_SIGNUP_EMAIL_VERIFIED: "Authentication Complete",
  ID_SIGNUP_EMAIL_VERIFIED_ERROR: "Waiting for authentication",
  ID_SIGNUP_SUCCESS: "Sign-up complete",
  ID_SIGNUP_CONFIRM: "Confirm",
  ID_SIGNUP_SENT_EMAIL_TITLE: "Email Sent",
  ID_SIGNUP_SENT_EMAIL_MSG: "The authenication email has been sent.",
  ID_SIGNUP_OVERLIMIT_ERR:
    "For nicknames, use up to 8 korean letters and 16 english and numeric combination.",
  ID_SIGNUP_DUPLICATE_ERR:
    "This nickname is already in use. Please enter a different nickname.",
  ID_SIGNUP_BADWORD_ERR:
    "The nickname contains a forbidden word. Please enter a different nickname.",
  ID_SIGNUP_PATTERN_ERR: "Nickname cannot contain spaces, special characters.",
};

export default SignUp_en;
